
<div class="experiment-dialog-header">
    <mat-toolbar id="dialog-titlebar" color="primary">
        <div>{{ data.isEditMode ? 'Edit' : 'Create' }} Experiment</div>
    </mat-toolbar>
</div>

<form [formGroup]="experimentForm" class="normal-form" (ngSubmit)="onSubmit()">
    <div mat-dialog-content class="experiment-dialog-content">
        <div class="experiment-controls-group">
            <mat-form-field appearance="outline" class="experiment-form-field">
                <mat-label>Name</mat-label>
                <input matInput id="name" type="text" data-testid="ic-experiment-dialog-name-input" aria-describedby="name-error" formControlName="name" />
                <mat-error id="name-error" *ngIf="experimentForm.controls.name.errors?.required">
                    This field is mandatory.
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="experiment-form-field">
                <mat-label>Description</mat-label>
                <textarea matInput id="description" data-testid="ic-experiment-dialog-description-input" aria-describedby="description-error" formControlName="description" rows="5"></textarea>
                <mat-error id="description-error" *ngIf="experimentForm.controls.description.errors?.required">
                    This field is mandatory.
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="experiment-form-field" subscriptSizing="dynamic" *ngIf="data.isEditMode || data.isReadOnly">
                <mat-label>Created By</mat-label>
                <input matInput data-testid="dialog-ic-experiment-createdby-input" [value]="data.experiment.createdByName" disabled />
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions class="experiment-dialog-actions">
        <div class="button-row" *ngIf="!data.isReadOnly">
            <button mat-raised-button color="warn" type="button" data-testid="ic-experiment-dialog-cancel-button" (click)="onCancel()"
                [disabled]="isLoading">Cancel</button>
            <button mat-raised-button color="primary" type="submit" data-testid="ic-experiment-dialog-ok-button"
                [disabled]="experimentForm.invalid || isLoading">
                Ok
            </button>
        </div>
        <div class="button-row" *ngIf="data.isReadOnly">
            <button mat-raised-button color="primary" type="button" data-testid="ic-experiment-dialog-close-button" (click)="onCancel()">Close</button>
        </div>
    </div>
</form>